import { isSearchError, SearchResponse } from 'src/types/search';

const PAGE_SIZE = 10;
const MAX_PAGES = 100;

const calculatePages = (size = 0): number[] => {
  const totalPages = Math.min(Math.ceil(size / PAGE_SIZE), MAX_PAGES);
  return [...Array(totalPages).keys()].map(pageItem => pageItem + 1);
};

export const getPagingProps = (response: SearchResponse) => {
  if (!response || isSearchError(response)) {
    return {
      count: 0,
      currentPage: 1,
      showPages: false,
      pages: [],
    };
  } else {
    const { size, page } = response;
    const pages = calculatePages(size);
    return {
      count: size,
      currentPage: page,
      showPages: pages.length > 1,
      pages,
    };
  }
};
